// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__24-Oh","buttons":"SendReceipts_buttons__2U5jk","email":"SendReceipts_email__1-TiG","bookApptTitle":"SendReceipts_bookApptTitle__25c6w"};